import { render, staticRenderFns } from "./StudentsNotebookDetails.vue?vue&type=template&id=ac49b572&scoped=true&"
import script from "./StudentsNotebookDetails.vue?vue&type=script&lang=js&"
export * from "./StudentsNotebookDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudentsNotebookDetails.vue?vue&type=style&index=0&id=ac49b572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac49b572",
  null
  
)

export default component.exports